<template>
  <div class="collector-stats-section">
    <SectionHeading>MyLittlePonyCollection Stats</SectionHeading>
    <div>
      <SiteStats
        v-if="siteStats && siteStats.length"
        :siteStats="siteStats"
      />
      <HerdStats
        :herdStats="herdStats"
        v-if="herdStats && herdStats.length"
      />
    </div>
  </div>
</template>

<script>
import SectionHeading from '../SectionHeading/SectionHeading';
import SiteStats from '../SiteStats/SiteStats';
import HerdStats from '../HerdStats/HerdStats';

export default {
  name: 'Stats',
  props: {
    siteStats: {
      type: Array,
      required: true
    },
    herdStats: {
      type: Array
    }
  },
  components: {
    SectionHeading,
    SiteStats,
    HerdStats
  }
};
</script>

<style scoped lang="scss">

@import '../../assets/sass/config';

.collector-stats-section {
  background-color: $light-teal;
  padding: 60px 10px 100px;

  @media (max-width: 568px) {
    padding-top: 10px;
    padding-bottom: 10px;
  }
}
</style>
